import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=afa1f71c&scoped=true&"
import script from "./GenericModal.vue?vue&type=script&lang=ts&"
export * from "./GenericModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa1f71c",
  null
  
)

export default component.exports